import React, { useEffect, useRef, useState } from "react";
import SecondaryButton from "@/shared/components/ui/Button/SecondaryButton";
import { PrimaryButton } from "@/shared/components/ui/Button/PrimaryButton";

const SettingsCommonLayout = ({
  children,
  title = "",
  description = "",
  cancelButtonClick,
  saveButtonClick,
  tab = "",
  isSubmitting = false,
  saveDisabled = false,
  cancelDisabled = false,
}) => {
  const descriptionRef = useRef(null);
  const [dynamicHeight, setDynamicHeight] = useState("h-[calc(100dvh-241px)]");

  const updateHeight = () => {
    if (descriptionRef.current) {
      const descHeight = descriptionRef.current.offsetHeight;
      if (descHeight > 30) {
        setDynamicHeight("h-[calc(100dvh-261px)]");
      } else {
        setDynamicHeight("h-[calc(100dvh-241px)]");
      }
    }
  };

  useEffect(() => {
    updateHeight();

    window.addEventListener("resize", updateHeight);
    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, [description]);

  return (
    <div className="w-full px-4 sm:px-6 lg:px-7">
      <div className="flex h-full w-full flex-col">
        <div className="py-3">
          {/* Header */}
          <div className="flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
            {/* Title & Description */}
            <div className="min-w-0 flex-1">
              <div className="flex flex-col gap-1">
                <h3 className="text-sm font-semibold text-gray-800 sm:text-base">
                  {title}
                </h3>

                <p
                  ref={descriptionRef}
                  className="break-words text-xs text-gray-500 sm:text-sm"
                >
                  {description}
                </p>
              </div>
            </div>

            {/* Settings Buttons */}
            {tab !== "billings_and_plans" &&
              tab !== "integrations" &&
              cancelButtonClick &&
              saveButtonClick && (
                <div className="flex w-full gap-2 md:w-auto md:flex-shrink-0 md:justify-end">
                  <SecondaryButton
                    title="Cancel"
                    onClick={cancelButtonClick}
                    className="flex-1 shadow-none md:flex-none"
                    disabled={cancelDisabled || isSubmitting}
                  />

                  <PrimaryButton
                    onClick={saveButtonClick}
                    startContent={false}
                    isLoading={isSubmitting}
                    disabled={isSubmitting || saveDisabled}
                    className="flex-1 md:flex-none"
                  >
                    Save
                  </PrimaryButton>
                </div>
              )}

            {/* Billing Buttons */}
            {tab === "billings_and_plans" && (
              <div className="flex w-full gap-2 md:w-auto md:flex-shrink-0 md:justify-end">
                <SecondaryButton
                  title="View Invoice History"
                  onClick={cancelButtonClick}
                  className="flex-1 md:flex-none"
                />

                <PrimaryButton
                  onClick={saveButtonClick}
                  startContent={false}
                  className="flex-1 md:flex-none"
                >
                  Manage Subscriptions
                </PrimaryButton>
              </div>
            )}
          </div>

          {/* Divider */}
          <div className="mt-4 h-px w-full bg-gray-200" />
        </div>

        {/* Content */}
        <div
          className={`${dynamicHeight} overflow-y-auto overflow-x-hidden pr-0 sm:pr-1`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default SettingsCommonLayout;
